import { HTMLAttributes } from "react";
import { ProductBaseInfo } from "../../model_def";
import rm from "../../utils/rm";
import util from "../../utils/util";
import Block from "../Base/Block";
import Image from "../Base/Image";
import Text from "../Base/Text";
import View from "../Base/View";
import Coin from "../Coin";
import Price from "../Price";
import './index.scss';
import SpaceHolder from "../SpaceHolder";

const CommonList = (prop: { 
  listName?: string, 
  sources: ProductBaseInfo[],
  headerExtra?: React.ReactNode,
 } & HTMLAttributes<HTMLDivElement>) => {

  const { listName, sources } = prop;

  console.log(listName, sources)

  return (<View className={`list-container ${prop.className || ''}`}>
    {!util.isEmpty(listName) && sources.length > 0 && (
      <View className="list-name">
        <span className="list-name-str">{listName}</span>
        <SpaceHolder/>
        {prop.headerExtra}
      </View>
    )}
    <View className="list-flow">
      {sources.map((listItem, listIndex) => {
        return (
          <View
            className="list-item"
            key={listItem.Id}
            data-index={listIndex}
            onClick={() => {
              util.navigateTo(`/detail?isrmmp=1&hidemenu=1&internal=1&id=${listItem.Id}`)
            }}
          >
            <View className="list-item-thumb-box">
              <Image
                className="list-item-thumb"
                src={listItem.PictureUrl}
                mode="aspectFill"
              ></Image>
            </View>
            <View className="list-item-meta">
              <Text className="list-item-title">{listItem.Name}</Text>
              <View className="list-item-sale">
                <View className="list-item-price">

                  {!!listItem.ProductPrice.MaxCoinCount ? <div style={{
                    display: "flex",
                    alignItems: "center"
                  }}>
                    <Coin count={listItem.ProductPrice.MaxCoinCount} size={24} />
                    {listItem.ProductPrice.MaxCoinMoney > 0 && <span>
                      <span style={{
                        marginLeft: 3,
                        marginRight: 3,
                        color: "#999"
                      }}>+</span><Price value={`¥${listItem.ProductPrice?.MaxCoinMoney}`} size={22}></Price>
                    </span>
                    }
                    {listItem.ProductPrice.PriceValue > 0 && listItem.ProductPrice.MaxCoinMoney === 0 && <span style={{
                      fontSize: 10,
                      color: "#999",
                      marginLeft: 6
                    }}>
                      ( 或<Price value={listItem.ProductPrice?.Price} size={20}></Price> )
                    </span>}
                  </div> : <Price value={listItem.ProductPrice?.Price} size={24}></Price>}
                  {listItem.ProductPrice.OldPrice != null && !listItem.ProductPrice.MaxCoinCount && (
                    <Block>
                      <Price
                        value={listItem.ProductPrice.OldPrice}
                        size={24}
                        color="#bbbbbb"
                        del={true}
                        style={{
                          marginLeft: '0.25rem',
                          fontWeight: 'normal',
                        }}
                      ></Price>
                    </Block>
                  )}
                </View>
                <Text
                  className="list-item-sale-count"
                  style={{
                    display: 'none',
                  }}
                >
                  245 月销
                </Text>
              </View>
            </View>
          </View>
        )
      })}
    </View>

    <View className="fix"></View>
  </View>)
}

export default CommonList;